var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41689_8434",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41689_8434)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#3C3B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 24.1667V15.8333C26.6663 14.0267 23.6138 12.5 19.9997 12.5C16.3855 12.5 13.333 14.0267 13.333 15.8333V24.1667C13.333 25.9733 16.3855 27.5 19.9997 27.5C23.6138 27.5 26.6663 25.9733 26.6663 24.1667ZM19.9997 14.1667C23.0755 14.1667 24.9422 15.4225 24.9997 15.8283C24.9422 16.2442 23.0755 17.5 19.9997 17.5C16.9238 17.5 15.0572 16.2442 14.9997 15.8383C15.0572 15.4225 16.9238 14.1667 19.9997 14.1667ZM14.9997 18.0058C16.2322 18.7117 18.0305 19.1667 19.9997 19.1667C21.9688 19.1667 23.7672 18.7117 24.9997 18.0058V19.995C24.9422 20.4108 23.0755 21.6667 19.9997 21.6667C16.9238 21.6667 15.0572 20.4108 14.9997 20V18.0058ZM14.9997 24.1667V22.1725C16.2322 22.8783 18.0305 23.3333 19.9997 23.3333C21.9688 23.3333 23.7672 22.8783 24.9997 22.1725V24.1617C24.9422 24.5775 23.0755 25.8333 19.9997 25.8333C16.9238 25.8333 15.0572 24.5775 14.9997 24.1667Z",
    fill: "#717070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashback);
export default __webpack_public_path__ + "static/media/cashback.db758e9a8b5e33cf031c455599e1d855.svg";
export { ForwardRef as ReactComponent };